import Springboard from './Springboard';

export default Springboard;
